import moment from 'moment-timezone'

function translate(number, withoutSuffix, key, isFuture) {
	switch (key) {
		case 'm':
			return '1' + (isFuture || withoutSuffix ? ' perc' : ' perce');
		case 'h':
			return '1' + (isFuture || withoutSuffix ? ' óra' : ' órája');
		case 'd':
			return '1' + (isFuture || withoutSuffix ? ' nap' : ' napja');
		case 'M':
			return '1' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
		case 'y':
			return '1' + (isFuture || withoutSuffix ? ' év' : ' éve');
		default:
			return '';
	}
}

moment.updateLocale('en', {
	relativeTime : {
		m:  '1 minute',
		h:  '1 hour',
		d:  '1 day',
		w:  '1 week',
		M:  '1 month',
		y:  '1 year',
	}
});

moment.updateLocale('fr', {
	relativeTime : {
		m:  '1 minute',
		h:  '1 heure',
		d:  '1 jour',
		w:  '1 semaine',
		M:  '1 mois',
		y:  '1 an',
	}
});

moment.updateLocale('nl', {
	relativeTime : {
		m: '1 minuut',
		h: '1 uur',
		d: '1 dag',
		w: '1 week',
		M: '1 maand',
		y: '1 jaar',
	}
});

moment.updateLocale('de', {
	relativeTime : {
		m: '1 Minute',
		h: '1 Stunde',
		d: '1 Tag',
		w: '1 Woche',
		M: '1 Monat',
		y: '1 Jahr',
	}
});

moment.updateLocale('hu', {
	relativeTime : {
		m: translate,
		h: translate,
		d: translate,
		w: translate,
		M: translate,
		y: translate,
	}
});
